const initialState = {
    selectedShelfType: null,
    shelfTypes: [],
    selectedProduct: null,
    products: []
};
  
  export default function MaintenanceReducer(state = initialState, action) {
    switch (action.type) {
      case "SET_SHELF_TYPE": {
        return {
            ...state,
            selectedShelfType: action.selectedShelfType,
        };
      }
      case "SET_SHELF_TYPES": {
        return {
            ...state,
            shelfTypes: action.shelfTypes,
        };
      }
      case "SET_PRODUCT": {
        return {
            ...state,
            selectedProduct: action.selectedProduct,
        };
      }
      case "SET_PRODUCTS": {
        return {
            ...state,
            products: action.products,
        };
      }
  
      default: {
        return state;
      }
    }
  }